import React from "react";
import {graphql} from "react-apollo";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import Form, {prepareValuesForSubmission, validateForm} from "./PartnerForm";
import {cancelCreatePartner, successCreatePartner} from "../../../actions/PartnerApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class CreatePartnerFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.createPartner(prepareValuesForSubmission(values).toJS())
      .then((response) => {
        if (response.data.createPartner.errors.length <= 0) {
          this.props.successCreatePartner();
        } else {
          this.setState({errors: createValidationErrors(response.data.createPartner.errors)});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  render() {
    return (
      <Form
        initialValues={fromJS({name: "", roles: this.props.role || "client", active: true})}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelCreatePartner()}
        />
    )
  }
}

const CREATE_PARTNER = gql`
  mutation createPartner($data: PartnerInput!) {
    createPartner(input: $data) {
      partnerId
      errors { key message }
    }
  }
`;

const withMutation = graphql(CREATE_PARTNER, {
  props: ({ mutate }) => ({
    createPartner: (data) => mutate({ variables: { data: data } })
  })
});

export default connect(null, {cancelCreatePartner, successCreatePartner})(withMutation(CreatePartnerFormContainer));
